"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var dimensions_1 = require("./../dimensions");

var cut_outs_1 = require("./../cut-outs");

var lodash_1 = require("lodash");

var lodash_2 = require("lodash");

var plate_element_1 = require("./plate-element");

var plate_elements_builder_1 = require("./plate-elements-builder");

var lodash_3 = require("lodash");

var defaults_1 = __importDefault(require("../defaults"));

var plate_builder_calc_1 = require("./plate-builder-calc"); // class Singleton<T> {
//   public static Instance<T>(c: {new(): T; }) : T{
//       if (this._instance == null){
//           this._instance = new c();
//       }
//       return this._instance;
//   }
//   private static _instance = null;
// }


var PlateBuilder =
/** @class */
function () {
  function PlateBuilder(conf, trough) {
    var _this = this;

    this.isSimulation = false; // Essentially, this is maximum distance allowed before a console is needed... different elements have different limits
    // Center to center

    this.overhangBetweenElements = function (from, to, preparedBackWallWith, consoleType) {
      if (consoleType === void 0) {
        consoleType = 'stainlessSteel';
      }

      var _a = dimensions_1.dimensions.techSpecs,
          freeOverhang = _a.freeOverhang,
          apronThickness = _a.apronThickness;
      var overhangKey;
      var overhang = 0;
      var isMiranit = consoleType === 'miranit';
      var isMZB = _this.conf.isVariusMedMzb; // Tap is same as trough basically...

      if (from === 'tap' || from === 'soap-dispenser') {
        from = 'trough';
      }

      if (to === 'tap' || to === 'soap-dispenser') {
        to = 'trough';
      } // Apron is same as edge basically...


      if (from === 'apron') {
        // overhang = overhang + apronThickness;
        from = 'edge';
      }

      if (to === 'apron') {
        // overhang = overhang + apronThickness;
        to = 'edge';
      } // Define the overhangs...


      var overhangs = {
        'trough-trough': preparedBackWallWith ? freeOverhang.betweenTroughsWithBackWall.max : 2 * freeOverhang.consoleToTrough.max,
        'trough-console': preparedBackWallWith ? freeOverhang.consoleWithBackwall.max : isMZB ? freeOverhang.consoleToTroughMZB.max : freeOverhang.consoleToTrough.max,
        'trough-angle-bar': preparedBackWallWith ? freeOverhang.angleBarWithBackwall.max : isMZB ? freeOverhang.angleBarToTroughMZB.max : freeOverhang.angleBar.max,
        'trough-edge': preparedBackWallWith ? freeOverhang.plateEdgeToTrough.max : freeOverhang.atEdgeLastConsole.max,
        'trough-cut-out': freeOverhang.cutOut.max,
        'console-console': freeOverhang.betweenConsoles.max,
        'console-angle-bar': freeOverhang.consoleToAngleBar.max,
        'console-edge': freeOverhang.atEdgeLastConsole.max,
        'console-cut-out': freeOverhang.cutOut.max,
        'consolecenteranchor-console': freeOverhang.betweenConsoles.max / 2,
        'angle-bar-angle-bar': freeOverhang.consoleToAngleBar.max,
        'angle-bar-cut-out': freeOverhang.cutOut.max,
        'edge-cut-out': freeOverhang.cutOut.max
      }; // console.log(overhangs);
      // TODO - If miranit console, then reduce overhang by 55?
      // Look for the overhang...

      if (typeof overhangs[from + '-' + to] !== 'undefined') {
        overhang = overhangs[from + '-' + to];
        overhangKey = from + '-' + to;
      } else if (typeof overhangs[to + '-' + from] !== 'undefined') {
        overhang = overhangs[to + '-' + from];
        overhangKey = to + '-' + from;
      } // All overhangs already include the 20mm reduction for half console, so have to increase this for miranit


      if (isMiranit) {
        if (from === 'console' || to === 'console') {
          overhang = overhang - 65;
        }

        if (overhangKey === 'console-console') {
          overhang = overhang - 65;
        } // Cant remember why I reduced overhang twice if its trough to console... however it was causing issue for ticket - https://ventzke-media.monday.com/boards/271536758/pulses/2592546522
        // if (overhangKey === 'trough-console') { 
        //   overhang = overhang - 65;
        // }

      } // Cheeky console fix... since we actually include a 10mm buffer, which is affecting the overhang calculations
      // In the spreadsheet, cutouts do actually include the buffer


      if (overhangKey === 'console-edge') {
        overhang = overhang - freeOverhang.atEdgeLastConsole.min;
      } // With corner radius reduces the overhang by another 10mm since it doesnt include buffer...
      // If I include buffer, then the stretchOverhangs moves the console 10mm from edge... 
      // console.log('over', from, to, overhang);


      return overhang;
    };

    this.populateWithConfOverrides = function (confOverrides, simulationOptions) {
      var currentProps = JSON.stringify(_this.conf.getProps);
      _this.conf.setProps = lodash_3.merge(JSON.parse(currentProps), confOverrides);
      _this.isSimulation = true;
      _this.confOverrides = confOverrides;
      _this.simulationOptions = simulationOptions;

      var components = _this.populate();

      _this.isSimulation = false;
      _this.confOverrides = undefined;
      _this.simulationOptions = undefined;
      _this.conf.setProps = JSON.parse(currentProps);
      return components;
    };

    this.populate = function () {
      // console.log('started populate');
      // TODO - Include MZB calculations... it includes freeOverhang.consoleAngleBarMzb.min instead of freeOverhang.console.min
      var _a = _this.conf,
          apronBackSplash = _a.apronBackSplash,
          builtInParts = _a.builtInParts,
          selectedTrough = _a.selectedTrough,
          washBasinDimension = _a.washBasinDimension;
      var drillHoles = dimensions_1.dimensions.techSpecs.drillHoles;
      var preparedBackWallWith = _this.trough.preparedBackWallWith; // Initializing plate

      var plate = _this.elementsBuilder.buildPlate({
        position: {
          x: 0,
          y: 1000,
          z: 0
        },
        scale: {
          x: 0,
          y: defaults_1.default.washBasinDimension.plateThickness.current,
          z: washBasinDimension && washBasinDimension.plateDepth > _this.trough.plateDepth.min ? washBasinDimension.plateDepth : _this.trough.plateDepth.min
        },
        materialName: _this.conf.surface && _this.conf.surface.color
      });

      plate.position.z = plate.scale.z / 2; // Sets the elementsBuilder plate, basically saving it after minPlateDepth for every other components call...
      // How can I make the plate available, but also fresh...
      // I tried creating new elementsBuilder before it didnt work
      // The components/plate which gets passed to the threeJsView is fine, because we set that in the initialiser
      // However, the elements get calculated with the elementsBuilder plate from minPlateDepth for some reason... why?
      // Because taps... when I call populate, I also get isDrillHoleAtBack, which calls plateMinDepth, which updates the elementsBuilder plate...
      // 
      // Basic trough details

      var qty = selectedTrough && selectedTrough.qty || 0;
      var typeOfInstallation = washBasinDimension && washBasinDimension.typeOfInstallation;
      var troughWidth = _this.trough.reqWidth; // TODO - Maybe should be throughWidth

      var troughHeight = _this.trough.throughOuterHeight || _this.trough.throughHeight;
      var medcareExtraDepth = _this.conf.isMedcare ? 80 : 0;
      var troughDepth = preparedBackWallWith ? _this.trough.plateDepth.min + medcareExtraDepth : _this.trough.throughDepth;
      var troughDepthPosition = preparedBackWallWith ? _this.trough.plateDepth.min - _this.trough.throughDepth - _this.trough.distBetween + _this.trough.distDrain + medcareExtraDepth : plate.sides.front - _this.trough.distBetween - _this.trough.throughDepth + _this.trough.distDrain; // 545 - 35 - 395 + 65 = 180 (centered on drain)

      var troughDepthCenter = troughDepthPosition - _this.trough.distDrain + _this.trough.throughDepth / 2; // 180 - 65 + 197.5 = 312.5
      // troughMaterial = troughMaterial === 'black-white' ? 'blackWhite' : troughMaterial; // We mix dashes with camelcase... should refactor, but for now just going to shim it for the 3D view
      // troughMaterial = troughMaterial === 'light-gray' ? 'lightGray' : troughMaterial;
      // Consoles

      var consoleType = _this.conf.selectedConsole || 'stainlessSteel';
      var consoleWidth = dimensions_1.dimensions.installaionParts.consoles[consoleType].min; // Corner design

      var cornerDesign = washBasinDimension && washBasinDimension.cornerDesign;
      var cornerDesignPosition = washBasinDimension && washBasinDimension.cornerDesignPosition;
      var cornerDesignWidth = cornerDesign && dimensions_1.dimensions.techSpecs.distance.cornerDesign[cornerDesign] || 0; // Soap dispenser

      var soapDispenserHole = builtInParts && builtInParts.soapDispenserHole;
      var soapDispenserHolePositions = builtInParts && builtInParts.soapDispenserHolePositions;
      var soapDispenserDrillHoleAllowed = _this.conf.defaults.builtInParts.soapDispenserHolePositions.isDrillHoleAllowed; // Its using the disabled checks to decide whether to render tap or not... but the rendering of taps is used to populate the disabled checks...
      // Tap hole

      var tapHole = builtInParts && builtInParts.tapHole;
      var tapHoleElementPositions = builtInParts && builtInParts.tapHolePositions;
      var tapHoleDrillHoleAllowed = _this.conf.defaults.builtInParts.tapHolePositions.isDrillHoleAllowed;
      var tapDrillHoleDistanceToTrough = _this.trough.drillHoleDistToCenter ? _this.trough.drillHoleDistToCenter - troughWidth / 2 - drillHoles.tap / 2 : 0;
      var tapDrillHoleDistanceToTroughBack = _this.trough.drillHoleDistToEdge || 0;
      var tapDrillHoleDepthPosition = preparedBackWallWith ? troughDepth / 2 : troughDepthCenter - troughDepth / 2 + tapDrillHoleDistanceToTroughBack; // Back of trough, then adding 30? weird...

      var isDrillHoleAtBack = _this.calc.isDrillHoleAtBackEnabled(); // Cutout


      var cutOutType = builtInParts && builtInParts.cutOutDisposalsType; // const cutOutCustomSettings = builtInParts && builtInParts.cutOutDisposalsCustomSettings || {width: 10, depth: 10};

      var calcCutOutDepthPosition = function calcCutOutDepthPosition(selectedCutOut) {
        return selectedCutOut && selectedCutOut.withRail ? troughDepthCenter // plate.sides.front - (selectedCutOut.reqDimensions.depth / 2) - selectedCutOut.buffer.front
        : preparedBackWallWith ? plate.position.z : troughDepthCenter;
      }; // Soap dispenser


      var soapDispenserDrillHoleDistanceToTrough = _this.trough.drillHoleDistToCenter ? _this.trough.drillHoleDistToCenter - troughWidth / 2 - drillHoles.soapDispenser / 2 : 0; // Minor helper functions

      _this.elementsBuilder.plate = plate; // Initializing elements

      var elements = []; // Initializing additional elements... these don't belong anywhere inside the order of the elements, they kind of just get added after... eg. apron front, surge back

      var additional = []; // Loop through troughs and populate elements...

      if (qty > 0) {
        var positionLimit = (qty + 1) * 3 - 4;

        for (var index = 0; index < qty; index++) {
          var isFirst = index === 0;
          var isLast = index === qty - 1; // For every single trough, we need to know the spacings between before we can insert a console
          // First Trough

          if (isFirst) {
            var hasCutOutFirst = _this.conf.hasCutOutAtIndex(index) || _this.conf.hasPaperTowelAtIndex(index);

            var hasTissueDispenserFirst = _this.conf.hasTissueDispenserAtIndex(index);

            if (typeOfInstallation === 'left' || typeOfInstallation === 'with') {
              elements.push(_this.elementsBuilder.buildPlain({
                type: 'wall',
                isFirst: isFirst,
                rotate: {
                  y: washBasinDimension && washBasinDimension.angleOfNiche && washBasinDimension.angleOfNiche[0] || 0
                }
              }));
            } else {
              elements.push(_this.elementsBuilder.buildPlain({
                type: 'edge',
                isFirst: true
              }));
            }

            if (typeOfInstallation === 'left' || typeOfInstallation === 'with') {
              // Wall on left
              // Angle-bar
              elements.push(_this.elementsBuilder.buildAngleBar({
                rotate: {
                  y: 90
                },
                isFirst: isFirst
              })); // if (this.conf.isVariusMedMzb) {
              //   elements.push(this.elementsBuilder.buildConsole({isFirst}));
              // }
            } else {
              // No Wall on left
              // Apron
              if (_this.conf.hasApron) {
                elements.push(_this.elementsBuilder.buildDepthApron({
                  isFirst: isFirst
                }, apronBackSplash && apronBackSplash.apronHeight || 0));
              } // Spacer for the corner radius if we have it


              if (_this.conf.hasLeftCorner) {
                // Maybe I cant use because this is creating a solid element, whereas we need to be smarter and figure out space
                var currentApronWidth = _this.conf.hasApron ? dimensions_1.dimensions.techSpecs.apronThickness + dimensions_1.dimensions.techSpecs.apronBuffer : 0;
                var otherAdjustment = consoleType === 'miranit' ? 65 : 0;
                elements.push(_this.elementsBuilder.buildSpacer({
                  position: {
                    x: plate.sides.left + (cornerDesignWidth - otherAdjustment) / 2 + currentApronWidth
                  },
                  scale: {
                    x: cornerDesignWidth - currentApronWidth - otherAdjustment
                  },
                  isFirst: isFirst
                }));
              } // Console if not preparedBackWallWith


              if (!preparedBackWallWith || preparedBackWallWith && (hasCutOutFirst || hasTissueDispenserFirst)) {
                elements.push(_this.elementsBuilder.buildConsole({
                  isFirst: isFirst
                }));
              }
            } // Safety catch


            if (!preparedBackWallWith) {
              // let safetyCatchBuffer = 90 + dimensions.installaionParts.consoles[consoleType].min;
              var safetyCatch = _this.elementsBuilder.buildSafetyCatch({
                isFirst: isFirst
              }); // safetyCatch.position.x = plate.sides.left + (dimensions.installaionParts.safetyCatch / 2) + safetyCatchBuffer;


              elements.push(safetyCatch);
            } // Add cut out
            // So we want to re-use the buildCutOut stuff I guess? 


            if (hasCutOutFirst) {
              var selectedCutOut = cut_outs_1.buildCutOutSpec(cutOutType, _this.conf, index);
              var dispenserCutOut = cut_outs_1.buildCutOutSpec('PROVIDER', _this.conf, index);
              var cutOutDepthPosition = calcCutOutDepthPosition(selectedCutOut);
              var cutout = _this.conf.hasCutOutAtIndex(index) ? selectedCutOut : dispenserCutOut;
              var railDepthOffset = plate.sides.front - selectedCutOut.reqDimensions.depth / 2 - selectedCutOut.buffer.front - cutOutDepthPosition + 15; // Its 15mm out and I dont know why, I dont want to change reqDimensions and I cant change dimensions
              // const buffer = selectedCutOut.buffer;
              // if (preparedBackWallWith) {
              //   const dummyConsole = this.elementsBuilder.buildConsole();
              //   buffer.right = buffer.right + dummyConsole.scale.x;
              // }

              elements.push(_this.elementsBuilder.buildCutOut({
                position: {
                  z: cutOutDepthPosition
                },
                // buffer,
                troughIndex: index,
                positionIndex: index,
                isFirst: isFirst
              }, cutout, railDepthOffset));
            }

            if (hasTissueDispenserFirst) {
              elements.push(_this.elementsBuilder.buildTissueDispenser({
                troughIndex: index,
                positionIndex: index,
                isLast: isLast
              }));
            } // If first trough, then add console after cut out


            if ((hasCutOutFirst || hasTissueDispenserFirst) && isFirst) {
              elements.push(_this.elementsBuilder.buildConsole({
                hidden: preparedBackWallWith
              }));
            }
          } // In-between console


          if (!isFirst) {
            if (!preparedBackWallWith) {
              elements.push(_this.elementsBuilder.buildConsole({
                hidden: preparedBackWallWith
              }));
            }

            var previousPositionIndex = (index + 2) * 3 - 5 - 1;

            var hasCutOutPreviously = _this.conf.hasCutOutAtIndex(previousPositionIndex) || _this.conf.hasPaperTowelAtIndex(previousPositionIndex);

            if (_this.conf.isVariusMedMzb && !hasCutOutPreviously) {
              elements.push(_this.elementsBuilder.buildConsole());
            }
          } // Tap/Soap-dispenser on left


          if (!isDrillHoleAtBack) {
            // this.conf.defaults.builtInParts.tapHoleElementPositions.isDrillHoleAllowed... might be better to use this, but not passed in at the moment
            var isTapDrillHoleAllowedAtPosition = _this.simulationOptions && _this.simulationOptions.forceRenderTaps || tapHoleDrillHoleAllowed[index] && tapHoleDrillHoleAllowed[index]['left'];

            if (tapHole && tapHoleElementPositions && tapHoleElementPositions.length > 0 && tapHoleElementPositions[index] === 'left' && isTapDrillHoleAllowedAtPosition) {
              elements.push(_this.elementsBuilder.buildTap({
                buffer: {
                  right: tapDrillHoleDistanceToTrough
                },
                position: {
                  z: tapDrillHoleDepthPosition
                },
                rotate: {
                  y: 40
                },
                isFirst: isFirst,
                isLast: isLast,
                troughIndex: index
              }));
            }

            var isSoapDispenserDrillHoleAllowedAtPosition = _this.simulationOptions && _this.simulationOptions.forceRenderSoapDispensers || soapDispenserDrillHoleAllowed[index] && soapDispenserDrillHoleAllowed[index]['left'];

            if (soapDispenserHole && soapDispenserHole !== 'without' && soapDispenserHolePositions && soapDispenserHolePositions.length > 0 && soapDispenserHolePositions[index] === 'left' && isSoapDispenserDrillHoleAllowedAtPosition) {
              // && soapDispenserDrillHoleAllowed[index] && soapDispenserDrillHoleAllowed[index]['left']) {
              elements.push(_this.elementsBuilder.buildSoapDispenser({
                buffer: {
                  right: soapDispenserDrillHoleDistanceToTrough
                },
                position: {
                  z: tapDrillHoleDepthPosition
                },
                rotate: {
                  y: 40
                },
                isFirst: isFirst,
                isLast: isLast,
                troughIndex: index
              }, soapDispenserHole));
            }
          } // Trough


          if (selectedTrough) {
            elements.push(_this.elementsBuilder.buildTrough({
              position: {
                z: troughDepthPosition
              },
              scale: {
                x: troughWidth,
                z: troughDepth,
                y: troughHeight + plate.scale.y
              },
              troughIndex: index,
              isFirst: isFirst,
              isLast: isLast
            }, selectedTrough.trough, isDrillHoleAtBack));
          } // Taps/Soap-dispensers on right


          if (!isDrillHoleAtBack) {
            var isTapDrillHoleAllowedAtPosition = _this.simulationOptions && _this.simulationOptions.forceRenderTaps || tapHoleDrillHoleAllowed[index] && tapHoleDrillHoleAllowed[index]['right'];

            if (tapHole && tapHoleElementPositions && tapHoleElementPositions.length > 0 && tapHoleElementPositions[index] === 'right' && isTapDrillHoleAllowedAtPosition) {
              elements.push(_this.elementsBuilder.buildTap({
                buffer: {
                  left: tapDrillHoleDistanceToTrough
                },
                position: {
                  z: tapDrillHoleDepthPosition
                },
                rotate: {
                  y: -40
                },
                isFirst: isFirst,
                isLast: isLast,
                troughIndex: index
              }));
            }

            var isSoapDispenserDrillHoleAllowedAtPosition = _this.simulationOptions && _this.simulationOptions.forceRenderSoapDispensers || soapDispenserDrillHoleAllowed[index] && soapDispenserDrillHoleAllowed[index]['right'];

            if (soapDispenserHole && soapDispenserHole !== 'without' && soapDispenserHolePositions && soapDispenserHolePositions.length > 0 && soapDispenserHolePositions[index] === 'right' && isSoapDispenserDrillHoleAllowedAtPosition) {
              elements.push(_this.elementsBuilder.buildSoapDispenser({
                buffer: {
                  left: soapDispenserDrillHoleDistanceToTrough
                },
                position: {
                  z: tapDrillHoleDepthPosition
                },
                rotate: {
                  y: -40
                },
                isFirst: isFirst,
                isLast: isLast,
                troughIndex: index
              }, soapDispenserHole));
            }
          } // In between cutouts...


          if (!isLast) {
            var startingPositionIndex = (index + 2) * 3 - 5;
            var firstConsoleAdded = false; // A bit dumb logic, but other logic was getting toooo complicated due to variations

            var hasCutOut1 = _this.conf.hasCutOutAtIndex(startingPositionIndex) || _this.conf.hasPaperTowelAtIndex(startingPositionIndex) || _this.conf.hasTissueDispenserAtIndex(startingPositionIndex);

            var hasCutOut2 = _this.conf.hasCutOutAtIndex(startingPositionIndex + 1) || _this.conf.hasPaperTowelAtIndex(startingPositionIndex + 1) || _this.conf.hasTissueDispenserAtIndex(startingPositionIndex + 1);

            var hasCutOut3 = _this.conf.hasCutOutAtIndex(startingPositionIndex + 2) || _this.conf.hasPaperTowelAtIndex(startingPositionIndex + 2) || _this.conf.hasTissueDispenserAtIndex(startingPositionIndex + 2);

            var needsConsole1 = (hasCutOut1 || hasCutOut2 || hasCutOut3) && !preparedBackWallWith;
            var needsConsole2 = hasCutOut1 && hasCutOut2 && !preparedBackWallWith;
            var needsConsole3 = (hasCutOut1 || hasCutOut2) && hasCutOut3 && !preparedBackWallWith;
            var needsConsole4 = (hasCutOut1 || hasCutOut2 || hasCutOut3) && !preparedBackWallWith;

            if (needsConsole1) {
              elements.push(_this.elementsBuilder.buildConsole({
                hidden: preparedBackWallWith
              }));
            }

            for (var iindex = 0; iindex < 3; iindex++) {
              var positionIndex = startingPositionIndex + iindex;

              var hasCutOutAtPosition = _this.conf.hasCutOutAtIndex(positionIndex) || _this.conf.hasPaperTowelAtIndex(positionIndex);

              var hasTissueDispenserAtPosition = _this.conf.hasTissueDispenserAtIndex(positionIndex);

              var needsInbetweenConsole = iindex === 1 && needsConsole2 || iindex === 2 && needsConsole3;

              if (needsInbetweenConsole) {
                elements.push(_this.elementsBuilder.buildConsole({
                  hidden: preparedBackWallWith
                }));
              }

              if (hasCutOutAtPosition) {
                var selectedCutOut = cut_outs_1.buildCutOutSpec(cutOutType, _this.conf, positionIndex);
                var dispenserCutOut = cut_outs_1.buildCutOutSpec('PROVIDER', _this.conf, positionIndex);
                var cutOutDepthPosition = calcCutOutDepthPosition(selectedCutOut);
                var cutout = _this.conf.hasCutOutAtIndex(positionIndex) ? selectedCutOut : dispenserCutOut;
                var railDepthOffset = plate.sides.front - selectedCutOut.reqDimensions.depth / 2 - selectedCutOut.buffer.front - cutOutDepthPosition + 15;
                elements.push(_this.elementsBuilder.buildCutOut({
                  position: {
                    z: cutOutDepthPosition
                  },
                  positionIndex: positionIndex,
                  troughIndex: index
                }, cutout, railDepthOffset));
              }

              if (hasTissueDispenserAtPosition) {
                elements.push(_this.elementsBuilder.buildTissueDispenser({
                  troughIndex: index,
                  positionIndex: positionIndex,
                  isLast: isLast
                }));
              }
            } // Gets added with next trough... which the next trough always adds because if no cutouts there still needs to be a console
            // if (needsConsole4) {
            //   elements.push(this.elementsBuilder.buildConsole({hidden: preparedBackWallWith}));
            // }

          } // Last trough


          if (isLast) {
            // Cut-out
            var hasCutOutLast = _this.conf.hasCutOutAtIndex(positionLimit - 1) || _this.conf.hasPaperTowelAtIndex(positionLimit - 1);

            var hasTissueDispenserLast = _this.conf.hasTissueDispenserAtIndex(positionLimit - 1);

            if (hasCutOutLast || hasTissueDispenserLast) {
              elements.push(_this.elementsBuilder.buildConsole({
                hidden: preparedBackWallWith
              }));
            }

            if (hasCutOutLast) {
              var selectedCutOut = cut_outs_1.buildCutOutSpec(cutOutType, _this.conf, positionLimit - 1);
              var dispenserCutOut = cut_outs_1.buildCutOutSpec('PROVIDER', _this.conf, positionLimit - 1);
              var cutOutDepthPosition = calcCutOutDepthPosition(selectedCutOut);
              var cutout = _this.conf.hasCutOutAtIndex(positionLimit - 1) ? selectedCutOut : dispenserCutOut;
              var railDepthOffset = plate.sides.front - selectedCutOut.reqDimensions.depth / 2 - selectedCutOut.buffer.front - cutOutDepthPosition + 15; // console.log(railDepthOffset, plate.sides.front, (selectedCutOut.reqDimensions.depth / 2), selectedCutOut.buffer.front, cutOutDepthPosition);
              // const buffer = selectedCutOut.buffer;
              // if (preparedBackWallWith) {
              //   const dummyConsole = this.elementsBuilder.buildConsole();
              //   buffer.left = buffer.left + dummyConsole.scale.x;
              // }

              elements.push(_this.elementsBuilder.buildCutOut({
                position: {
                  z: cutOutDepthPosition
                },
                // buffer,
                troughIndex: index + 1,
                positionIndex: positionLimit - 1,
                isLast: isLast
              }, cutout, railDepthOffset));
            }

            if (hasTissueDispenserLast) {
              elements.push(_this.elementsBuilder.buildTissueDispenser({
                troughIndex: index + 1,
                positionIndex: positionLimit - 1,
                isLast: isLast
              }));
            } // Safety catch


            if (!preparedBackWallWith) {
              // let safetyCatchBuffer = 90 + dimensions.installaionParts.consoles[consoleType].min;
              var safetyCatch = _this.elementsBuilder.buildSafetyCatch({
                isLast: isLast
              }); // safetyCatch.position.x = plate.sides.right - (dimensions.installaionParts.safetyCatch / 2) - safetyCatchBuffer;


              elements.push(safetyCatch);
            } // Spacing between wall/edge


            if (typeOfInstallation === 'right' || typeOfInstallation === 'with') {
              // Only for wall on right
              // if (this.conf.isVariusMedMzb) {
              //   elements.push(this.elementsBuilder.buildConsole({isLast}));
              // }
              // Wall is set to right or with.
              elements.push(_this.elementsBuilder.buildAngleBar({
                rotate: {
                  y: -90
                },
                isLast: isLast
              }));
            } else {
              // Without wall on right
              // Only include console if not prepared backwall
              if (!preparedBackWallWith || preparedBackWallWith && hasCutOutLast) {
                elements.push(_this.elementsBuilder.buildConsole({
                  isLast: isLast
                }));
              } // Spacer for the corner radius if we have it


              if (_this.conf.hasRightCorner) {
                var currentApronWidth = _this.conf.hasApron ? dimensions_1.dimensions.techSpecs.apronThickness + dimensions_1.dimensions.techSpecs.apronBuffer : 0;
                var otherAdjustment = consoleType === 'miranit' ? 65 : 0;
                elements.push(_this.elementsBuilder.buildSpacer({
                  scale: {
                    x: cornerDesignWidth - currentApronWidth - otherAdjustment
                  },
                  isLast: isLast
                }));
              } // Add apron if exists


              if (_this.conf.hasApron) {
                elements.push(_this.elementsBuilder.buildDepthApron({
                  isLast: isLast
                }, apronBackSplash && apronBackSplash.apronHeight || 0));
              }
            } // Add edge/wall


            if (typeOfInstallation === 'right' || typeOfInstallation === 'with') {
              elements.push(_this.elementsBuilder.buildPlain({
                type: 'wall',
                isLast: isLast,
                rotate: {
                  y: washBasinDimension && washBasinDimension.angleOfNiche && washBasinDimension.angleOfNiche[typeOfInstallation === 'with' ? 1 : 0] || 0
                }
              }));
            } else {
              elements.push(_this.elementsBuilder.buildPlain({
                type: 'edge',
                isLast: isLast
              }));
            }
          }
        }
      } // Setting up plate padding/buffer... which is basically what the troughs can move around inside of


      if (washBasinDimension && washBasinDimension.plateWidth) {
        plate.scale.x = washBasinDimension && washBasinDimension.plateWidth || 0;
      } else {
        // Its proving difficult to align all the elements and then calculate the min width based on last element position... instead I will just add up all the scales/buffers of elements
        plate.scale.x = elements.reduce(function (accu, element) {
          return accu + element.outerWidth;
        }, 0);
      } // Add left positions to elements


      elements = _this.affixTroughs(elements, plate); // All elements have position.x === 0 at this point...

      elements = _this.affixElements(elements, plate); // Have to affix elements before setting left... otherwise if we set left, then affix something, the next element becomes out of date
      // elements = this.dynamicBufferConsoles(elements, plate); // First/last console can be up to 100mm from the edge...
      // I am starting to realise why I use buffer... its because buffer was needed to set the plate width, maybe...
      // Right now having a problem but 
      // elements = this.injectPositionIntoElements(elements, plate, ['console']); // Mainly setting console position, otherwise since its still "0" it gets limitOverhang applied which fixes it
      // elements = this.injectPositionIntoElements(elements, plate, ['apron']); // Have to set apron position, otherwise first apron is set to "0", which messes up the next console position when we stretchOverhangs

      elements = _this.stretchOverhangs(elements); // if (!this.isSimulation) {
      //   console.log('stretchOverhangs', JSON.parse(JSON.stringify(elements)));
      // }
      // elements = this.centerConsoles(elements); // Centering this before adding positions to troughs seems to make MZB broken
      // elements = this.limitOverhangs(elements);
      // if (!this.isSimulation) {
      //   console.log('stretched & limited', JSON.parse(JSON.stringify(elements)));
      // }

      elements = _this.affixElements(elements, plate); // Affix twice... because the safety catch checks if the console is fixed before setting its position
      // Affix just does edge elements basically, nothing to do with troughs

      elements = _this.injectPositionIntoElements(elements, plate);
      elements = _this.affixTapsToTroughs(elements, plate); // Affix taps to troughs after injecting position... if we set before then troughs might not have distances and thus taps start from 0
      // elements = this.centerElements(elements, 'cut-out'); // Center the cut-outs after affixing elements and setting up initial left positions...
      // if (!this.isSimulation) {
      //   console.log('before console injection loop', JSON.parse(JSON.stringify(elements)));
      // }

      plate.position.x = plate.scale.x / 2;
      _this.elementsBuilder.plate = plate; // Refresh elementsBuilder
      // The adjustment loop... it will keep going through, spacing elements, injecting consoles, spacing elements, etc

      var originalElements = [];
      var adjustments = 0;
      var disabledConsoles = _this.simulationOptions && _this.simulationOptions.disableConsoles;

      if (elements.length > 0 && !disabledConsoles) {
        // If we ever get the same set of elements back, then stop trying to adjust...
        // Not intensively tested, so putting in a loop escape
        // elements = this.addOverhangNumbers(elements);
        // console.log('preadjusted', JSON.parse(JSON.stringify(elements)));
        while (JSON.stringify(elements) !== JSON.stringify(originalElements) && adjustments <= 50) {
          // TODO - Revert to 50
          // Start off by assigning adjustedElements to elements... this means at the end of the changes, we can compare if they have changed
          // This is stripping all my functions... lol
          originalElements = JSON.parse(JSON.stringify(elements)); // console.log('adjusting '+adjustments, adjustedElements);
          // stretched false
          // But how does the stretched false even get through?... maybe because it checks overhang distance, and only if the overhang distance needs to be moved then it sets it to isStretched false
          // So... I can fix this easily by just resetting state when centering... but is there a way to get it working with other consoles too?
          // Inside stretchOverhangsLeftToRight, maybe I can check if the distance is at the limit, and then set isStretched to true?
          // stretched true
          // // Affix the elements... eg. last console to edge... 

          elements = _this.affixElements(elements, plate); // elements = this.dynamicBufferConsoles(elements, plate); // First/last console can be up to 100mm from the edge... first/last console could be added by preparedBackwall troughs so have to add calc here too, agh
          // // Evenly spacing non-isFixed consoles, and affixing the rest, before we try to inject more
          // elements = this.affixConsolesToElements(elements, preparedBackWallWith);
          // elements = this.centerElements(elements);
          // elements = this.resetStates(elements); // isStretched and isLimited to false

          elements = _this.stretchOverhangs(elements); // Only for first/last consoles
          // elements = this.limitOverhangs(elements);

          elements = _this.centerConsoles(elements); // if (!this.isSimulation) {
          //   elements = this.addOverhangNumbers(elements);
          //   console.log('stretched', JSON.parse(JSON.stringify(elements)));
          //   if (adjustments === 1) { // Exit while loop for preview...
          //     break;
          //   }
          // }
          // Add extra consoles...
          // This has to be done before and also after injecting consoles, since prepared-backwall doesn't start with consoles but others do

          elements = _this.injectConsolesIntoElements(plate, elements, preparedBackWallWith); // Just centering between troughs means it could overlap with another element (eg. cut-out/taps or whatever)
          // Actually, center elements if using troughs as wrappers too... so it could be trough to far cut-out, and a trough/cut-out has different overhang rules, so centering would break it there
          // What I need to do, is do centering and compare console count... if console count is same then keep it
          // Must still only have 1 console left - http://localhost:3300/configuration/637b2e7277f4850ef4bbbf58/basin-dimensions - and not central console
          // let elementsCentered = this.centerElements(JSON.parse(JSON.stringify(elements)));
          // elementsCentered = this.injectConsolesIntoElements(plate, elementsCentered, preparedBackWallWith);
          // Need to come up with a better centering solution which still respects overhangs... comparing console count is a cool idea
          // Always going to be the same maybe? Since we only center consoles between fixed consoles now...
          // const consolesWithCentering = elementsCentered.filter((e) => e.type === 'console');
          // const consolesWithoutCentering = elements.filter((e) => e.type === 'console');
          // if (consolesWithCentering.length === consolesWithoutCentering.length) {
          //   elements = this.centerElements(elements);
          // }

          if (!_this.isSimulation) {
            elements = _this.addOverhangNumbers(elements);
          } // If we have an element inside an element that shouldn't be, we should move it
          // adjustedElements = this.shiftOverlappingElements(adjustedElements);


          adjustments++;

          if (adjustments === 50) {
            // TODO - THIS IS DEBUG
            console.log('ERROR - Infinite adjustments'); // console.log('this.isSimulation', this.isSimulation);
            // console.log('this.confOverrides', this.confOverrides);
            // console.log('this.simulationOptions', this.simulationOptions);
            // console.log(JSON.parse(JSON.stringify(originalElements)), JSON.parse(JSON.stringify(elements)));
          }
        }
      } // Lengthwise additional elements


      if (plate.scale.x > 0 && plate.scale.z > 0) {
        // Apron
        if (apronBackSplash && apronBackSplash.apron === 'with' && apronBackSplash.apronHeight) {
          additional.push(_this.elementsBuilder.buildWidthApron(null, apronBackSplash.apronHeight));
        } // Surge-edge


        if (apronBackSplash && apronBackSplash.surgeEdgeOrBackSplash === 'withSurgeEdge') {
          additional.push(_this.elementsBuilder.buildWidthSurgeEdge());

          if (apronBackSplash.positionOfEdgeOrBacksplash) {
            // Left
            if (apronBackSplash.positionOfEdgeOrBacksplash.indexOf('left') > -1) {
              additional.push(_this.elementsBuilder.buildDepthSurgeEdge({
                position: {
                  x: plate.sides.left + dimensions_1.dimensions.techSpecs.backSplashThickness / 2
                },
                isFirst: true
              }));
            } // Right


            if (apronBackSplash.positionOfEdgeOrBacksplash.indexOf('right') > -1) {
              additional.push(_this.elementsBuilder.buildDepthSurgeEdge({
                position: {
                  x: plate.sides.right - dimensions_1.dimensions.techSpecs.backSplashThickness / 2
                },
                isLast: true
              }));
            }
          }
        } // Backsplash


        if (apronBackSplash && apronBackSplash.surgeEdgeOrBackSplash === 'withBackSplash' && apronBackSplash.backsplashHeight) {
          additional.push(_this.elementsBuilder.buildWidthBackSplash(null, apronBackSplash.backsplashHeight));

          if (apronBackSplash.positionOfEdgeOrBacksplash) {
            // Left
            if (apronBackSplash.positionOfEdgeOrBacksplash.indexOf('left') > -1) {
              additional.push(_this.elementsBuilder.buildDepthBackSplash({
                position: {
                  x: plate.sides.left + dimensions_1.dimensions.techSpecs.surgeEdgeThickness / 2
                },
                isFirst: true
              }, apronBackSplash.backsplashHeight));
            } // Right


            if (apronBackSplash.positionOfEdgeOrBacksplash.indexOf('right') > -1) {
              additional.push(_this.elementsBuilder.buildDepthBackSplash({
                position: {
                  x: plate.sides.right - dimensions_1.dimensions.techSpecs.surgeEdgeThickness / 2
                },
                isLast: true
              }, apronBackSplash.backsplashHeight));
            }
          }
        } // Corner radius


        if (cornerDesignWidth > 0 && cornerDesignPosition) {
          var apron = lodash_1.filter(additional, function (e) {
            return e.type === 'apron';
          })[0];

          if (cornerDesignPosition.indexOf('left') > -1) {
            var leftCornerRadius = _this.elementsBuilder.buildCornerRadius({
              position: {
                x: plate.sides.left + cornerDesignWidth
              },
              shape: cornerDesign,
              isFirst: true
            });

            if (apron) {
              leftCornerRadius.scale.y = apron.scale.y;
              leftCornerRadius.position.y = apron.position.y;
            }

            additional.push(leftCornerRadius);
          } // Right


          if (cornerDesignPosition.indexOf('right') > -1) {
            var rightCornerRadius = _this.elementsBuilder.buildCornerRadius({
              position: {
                x: plate.sides.right - cornerDesignWidth
              },
              shape: cornerDesign,
              rotate: {
                y: -90
              },
              isLast: true
            });

            if (apron) {
              rightCornerRadius.scale.y = apron.scale.y;
              rightCornerRadius.position.y = apron.position.y;
            }

            additional.push(rightCornerRadius);
          }
        } // Gelcoat


        if (_this.conf.surface && _this.conf.surface.gelCoat) {
          var gelCoat = _this.elementsBuilder.buildGelCoat();

          additional.push(gelCoat);
        } // Sticker


        var sticker = _this.elementsBuilder.buildSticker();

        additional.push(sticker);
      } // Add cosmetic tissue dispensers... we do it here because things get funky if I try to overlay it and add consoles etc
      // additional = [...additional, ...this.populateTissueDispensers(elements)];
      // Make inner elements relative to their container element...


      elements = _this.makeInnerElementsRelative(elements);
      additional = _this.makeInnerElementsRelative(additional); // Make angle-bars flush to left/right

      elements = _this.makeAngleBarsFlush(elements); // console.log(JSON.stringify(elements, null, 2));
      // console.log({
      //   elements,
      //   plate,
      //   additional
      // });
      // Hide consoles... we do this finally, because we want to make sure console spacings are included in previous calculations

      if (_this.conf.assemblyAccessories && !_this.conf.assemblyAccessories.selection) {
        elements = _this.hideElementsByType(elements, 'console');
        elements = _this.hideElementsByType(elements, 'angle-bar');
      } // Centered from middle of next trough, but not the left side of the next trough... aghhhh
      // console.log('elements', elements);
      // console.log('finished populate');


      return {
        elements: elements,
        plate: plate,
        additional: additional
      };
    };

    this.resetStates = function (elements) {
      elements.forEach(function (element, index) {
        element.isStretched = false;
        element.isLimited = false; // Maybe not being used anymore
      });
      return elements;
    };

    this.injectPositionIntoElements = function (elements, plate, elementTypes) {
      if (elementTypes === void 0) {
        elementTypes = [];
      }

      elements.forEach(function (element, index) {
        var prevElement = elements[index - 1];

        if (!prevElement || element.hasPositionSet || elementTypes.length > 0 && !elementTypes.includes(element.type)) {
          return;
        } // Set to right of previous element...


        if (prevElement) {
          element.position.x = prevElement.outerSides.right + element.scale.x / 2 + element.buffer.left;
        } // We don't want to add negative buffers if the previous/next element is an edge/wall, otherwise components will go out of bounds
        // if (prevElement.type !== 'console' || element.type !== 'console') { // We dont add buffer to consoles? hmm... seems wrong
        //   if ((prevElement.type !== 'edge' && prevElement.type !== 'wall') || element.buffer.left > 0) {
        //     element.position.x = element.position.x + element.buffer.left;
        //   }
        //   if ((element.type !== 'edge' && element.type !== 'wall') || prevElement.buffer.right > 0) {
        //     element.position.x = element.position.x + prevElement.buffer.right;
        //   }
        // }

      });
      return elements;
    }; // Affixing troughs...


    this.affixTroughs = function (elements, plate) {
      var troughDistances = _this.conf.washBasinDimension && _this.conf.washBasinDimension.distances;
      elements.forEach(function (element, index) {
        if (element.type === 'trough' && troughDistances && typeof element.troughIndex !== 'undefined' && !element.hasPositionSet) {
          // If trough, then get the distance/position from the config
          element.position.x = troughDistances[element.troughIndex];
        } // Making the position isFixed/immovable if position adjusted and last/first/trough


        if (element.hasPositionSet && (element.isLast || element.isFirst || !element.isCenterableElement)) {
          element.isFixed = true;
        }
      });
      return elements;
    }; // Affixing elements... eg. last console to edge of plate


    this.affixElements = function (elements, plate) {
      // Affix the elements... eg. attach consoles to ends of plate etc
      elements.forEach(function (element, index) {
        var prevElement = elements[index - 1];
        var nextElement = elements[index + 1];

        if (element.type === 'cut-out' && typeof element.positionIndex !== 'undefined') {
          var spacePositions = _this.calc.spacePositions(element, elements, false);

          element.position.x = spacePositions[element.positionIndex];
        } else if (plate.hasScaleSet && (element.isEdgeElement && element.isLast || element.isAssemblyElement && nextElement.isEdgeElement && !element.isStretched // If we dont look at isStretched then it tries to move console flush to edge
        // || (element.type === 'safety-catch' && element.isLast)
        || element.type === 'spacer' && element.isLast // || (plateWidth && plateWidth > 0 && element.type === 'trough' && element.isLast && element.sides.right > plate.scale.x) // This made the trough stick to end of the plate, I used to use it for calculating trough range, might be useful in future
        )) {
          // If console/angle-bar is last, then make position stick to right of plateWidth
          var nextElements = elements.slice(index + 1, elements.length);
          var nextElementsWidths = nextElements ? nextElements.reduce(function (accumulator, el) {
            return accumulator + el.scale.x + (el.buffer.left > 0 ? el.buffer.left : 0) + (el.buffer.right > 0 ? el.buffer.right : 0);
          }, 0) : 0; // Maybe I can look at the elements negative buffer to pull it under but not inside the console?

          element.position.x = plate.scale.x - nextElementsWidths - element.scale.x / 2 - (element.buffer.right > 0 ? element.buffer.right : 0);
          element.isFixed = true;
        } else if (element.isAssemblyElement && prevElement.isEdgeElement && element.isFirst && !element.isStretched) {
          // If console/angle-bar is first, then make position stick to left of plateWidth
          var prevElements = elements.slice(0, index);
          var prevElementsWidths = prevElements ? prevElements.reduce(function (accumulator, el) {
            return accumulator + el.scale.x + (el.buffer.right > 0 ? el.buffer.right : 0) + (el.buffer.left > 0 ? el.buffer.left : 0);
          }, 0) : 0;
          element.position.x = 0 + prevElementsWidths + element.scale.x / 2 + (element.buffer.left > 0 ? element.buffer.left : 0);
          element.isFixed = true;
        } else if (element.type === 'safety-catch' && element.isLast) {
          element.position.x = nextElement.outerSides.left - element.scale.x / 2 - (element.buffer.right > 0 ? element.buffer.right : 0);
          element.isFixed = true;
        } else if (element.type === 'safety-catch' && element.isFirst) {
          element.position.x = prevElement.outerSides.right + element.scale.x / 2 + (element.buffer.left > 0 ? element.buffer.left : 0);
          element.isFixed = true;
        } // Making the position isFixed/immovable if position adjusted and last/first/trough


        if (element.hasPositionSet && (element.isLast || element.isFirst || !element.isCenterableElement)) {
          element.isFixed = true;
        }
      });
      return elements;
    };

    this.affixTapsToTroughs = function (elements, plate) {
      elements.forEach(function (element, index) {
        if (element.type !== 'trough') {
          return;
        }

        var nextElement = elements[index + 1];
        var prevElement = elements[index - 1]; // If prev/next element is tap, position it to be directly before/after trough

        if (prevElement && (prevElement.type === 'tap' || prevElement.type === 'soap-dispenser')) {
          prevElement.position.x = element.outerSides.left - prevElement.scale.x / 2 - prevElement.buffer.right;
          prevElement.isFixed = true;
        }

        if (nextElement && (nextElement.type === 'tap' || nextElement.type === 'soap-dispenser')) {
          nextElement.position.x = element.outerSides.right + nextElement.scale.x / 2 + nextElement.buffer.left;
          nextElement.isFixed = true;
        }
      });
      return elements;
    }; // Manually moving elements... eg, console to each side of trough


    this.affixConsolesToElements = function (elements, preparedBackWallWith) {
      elements.forEach(function (element, index) {
        // We let cut-out skip the preparedBackwall check, this is because the spreadsheet states to always place a console around the cut-out...
        var isAffixableElement = element.type === 'cut-out' || !preparedBackWallWith && element.isAffixableElement; // (element.type === 'cut-out' || (!preparedBackWallWith && element.isAffixableElement));
        // Have new issue, where console is sent farrr away and overlaps the next safety-catch/console... have to make it so that it stops at safety catch

        if (isAffixableElement) {
          var spaceAroundElement = _this.simulationOptions && _this.simulationOptions.disableExtendOverhangs ? {
            left: 0,
            right: 0
          } : _this.calc.spaceAroundElement(element, elements, ['angle-bar', 'console']); // Get previous consoles until trough is found...

          var prevElements = elements.slice(0, index).reverse() || [];

          var prevElementsUntilAffixable = _this.calc.splitElementsAtTypes(plate_element_1.affixableElements, prevElements);

          var prevConsolesUntilAffixable = prevElementsUntilAffixable.filter(function (e) {
            return e.type === 'console' || e.type === 'angle-bar';
          });
          var isManyPrevAffixableConsoles = prevConsolesUntilAffixable.length > 1 && !prevConsolesUntilAffixable[0].isFixed;
          var prevElementLimit = prevElements.find(function (e) {
            return e.type !== 'console' && e.type !== 'angle-bar';
          }); // Get next consoles until trough is found...

          var nextElements = elements.slice(index + 1, elements.length) || [];

          var nextElementsUntilAffixable = _this.calc.splitElementsAtTypes(plate_element_1.affixableElements, nextElements);

          var nextConsolesUntilAffixable = nextElementsUntilAffixable.filter(function (e) {
            return e.type === 'console' || e.type === 'angle-bar';
          });
          var isManyNextAffixableConsoles = nextConsolesUntilAffixable.length > 1 && !nextConsolesUntilAffixable[0].isFixed;
          var nextElementLimit = nextElements.find(function (e) {
            return e.type !== 'console' && e.type !== 'angle-bar';
          });
          spaceAroundElement.left = spaceAroundElement.left - 40;
          spaceAroundElement.right = spaceAroundElement.right - 40;

          if (spaceAroundElement.left < 0) {
            spaceAroundElement.left = 0;
          }

          if (spaceAroundElement.right < 0) {
            spaceAroundElement.right = 0;
          } // SpaceAroundElement should be handling the correct max distance from trough for us...


          var overhang = _this.overhangBetweenElements('console', element.type, preparedBackWallWith, _this.conf.selectedConsole);

          spaceAroundElement.left = spaceAroundElement.left > overhang ? overhang : spaceAroundElement.left;
          spaceAroundElement.right = spaceAroundElement.right > overhang ? overhang : spaceAroundElement.right;

          if (isManyPrevAffixableConsoles) {
            var prevConsole = prevConsolesUntilAffixable[0];
            prevConsole.position.x = element.outerSides.left - prevConsole.scale.x / 2 - prevConsole.buffer.right - spaceAroundElement.left;
            prevConsole.isFixed = true;
          }

          if (isManyNextAffixableConsoles) {
            var nextConsole = nextConsolesUntilAffixable[0];
            nextConsole.position.x = element.outerSides.right + nextConsole.scale.x / 2 + nextConsole.buffer.left + spaceAroundElement.right;
            nextConsole.isFixed = true;
          }
        }
      });
      return elements;
    };

    this.addOverhangNumbers = function (elements, isReversed) {
      if (isReversed === void 0) {
        isReversed = false;
      }

      elements.forEach(function (element, index) {
        if (!element.isOverhangElement) {
          return;
        }

        var nextElements = elements.slice(index + 1, elements.length) || [];
        var nextOverhangElement = nextElements.filter(function (e) {
          return e.isOverhangElement && !e.hidden;
        })[0];

        if (!nextOverhangElement) {
          element.overhangDistance = 0;
          element.overhangThreshold = 0;
          element.nextConsolePosition = 0;
          return;
        } // if (!this.isSimulation) {
        //   console.log('overhang numbers', JSON.parse(JSON.stringify(element)), JSON.parse(JSON.stringify(nextOverhangElement)));
        // }


        var overhangDistance;

        if (isReversed) {
          overhangDistance = element.sides.left - nextOverhangElement.sides.right;
        } else {
          overhangDistance = nextOverhangElement.sides.left - element.sides.right;
        } // Maybe I can exclude apron here somehow... maybe 


        var overhangThreshold = _this.overhangBetweenElements(element.type, nextOverhangElement.type, _this.trough.preparedBackWallWith, _this.conf.selectedConsole);

        if (element.type === 'edge') {
          if (_this.conf.hasLeftCorner && element.isFirst) {
            overhangThreshold = overhangThreshold + 10; /// Have to offset the reduction we do in function ugh...
          }

          if (_this.conf.hasRightCorner && element.isLast) {
            overhangThreshold = overhangThreshold + 10; /// Have to offset the reduction we do in function ugh...
          }
        } // if (!this.isSimulation) {
        //   console.log(overhangThreshold, element.type, nextOverhangElement.type, this.trough.preparedBackWallWith, this.conf.selectedConsole);
        // }


        if (isReversed) {
          overhangThreshold = overhangThreshold + (nextOverhangElement.buffer.left > 0 ? nextOverhangElement.buffer.left : 0);
        } else {
          overhangThreshold = overhangThreshold + (element.buffer.right > 0 ? element.buffer.right : 0);
        }

        var nextConsolePosition = overhangThreshold;

        if (isReversed) {
          overhangThreshold = overhangThreshold + (element.buffer.right > 0 ? element.buffer.right : 0);
        } else {
          overhangThreshold = overhangThreshold + (nextOverhangElement.buffer.left > 0 ? nextOverhangElement.buffer.left : 0);
        } // The numbers look like they are including the buffer, but actually since the threshold and distance both include the buffer it kind of cancels out... so we can leave them in


        element.overhangDistance = overhangDistance;
        element.overhangThreshold = overhangThreshold;
        element.nextConsolePosition = nextConsolePosition;
      });
      return elements;
    }; // Edge has to be included in overhang elements and I guess it needs to be counted as edge for overhang amount? hmm
    // Since at the moment, console are being injected after the apron which is wrong!
    // Add extra consoles...


    this.injectConsolesIntoElements = function (plate, elements, preparedBackWallWith) {
      var newConsoles = [];
      elements = _this.addOverhangNumbers(elements); // if (!this.isSimulation) {
      //   console.log('injecting consoles into elements', JSON.parse(JSON.stringify(elements)));
      // }

      elements.forEach(function (element, index) {
        if (!element.isOverhangElement || !element.overhangThreshold || !element.overhangDistance || !element.nextConsolePosition) {
          return;
        }

        var nextElement = elements[index + 1];
        var nextElements = elements.slice(index + 1, elements.length) || [];
        var nextOverhangElement = nextElements.filter(function (e) {
          return e.isOverhangElement || e.type === 'apron';
        })[0]; // Apron shouldnt affect hangover distances, but need to avoid injecting after it

        var nextOverhangElementIndex = lodash_2.findIndex(elements, function (e) {
          return JSON.stringify(e) === JSON.stringify(nextOverhangElement);
        });

        if (element.type === 'edge' && nextOverhangElement && nextOverhangElement.type === 'console' || element.type === 'console' && nextOverhangElement && nextOverhangElement.type === 'edge') {
          return;
        } // If the space between current and next element is larger than when we should place console, then place it


        var needsConsole = element.overhangDistance > element.overhangThreshold;

        if (needsConsole) {
          // Make console visible if it already exists...
          if (nextOverhangElement.type === 'console' && nextOverhangElement.hidden) {
            nextOverhangElement.hidden = false;
          } else {
            var newConsoleElement = _this.elementsBuilder.buildConsole();

            newConsoleElement.position.x = element.sides.right + element.nextConsolePosition + newConsoleElement.scale.x / 2; // This used to be negative but now positive... I made addition because we already reduce overhang distance by 65mm if MZB, to make it pretend to be 40mm console...

            newConsoleElement.spliceIndex = nextOverhangElementIndex;

            if (element.type === 'trough' && (nextElement.type === 'tap' || nextElement.type === 'soap-dispenser')) {
              // If next element is tap, we have to add console after that and not before...
              newConsoleElement.spliceIndex = newConsoleElement.spliceIndex + 1;
            }

            if (nextElement) {
              if (nextElement.type === 'spacer' && nextElement.isLast) {
                // Inject before spacer...
                newConsoleElement.spliceIndex = newConsoleElement.spliceIndex - 1; // Affix to spacer

                if (newConsoleElement.position) {
                  newConsoleElement.position.x = nextElement.outerSides.left - newConsoleElement.scale.x / 2;
                  newConsoleElement.isFixed = true;
                  newConsoleElement.isLast = true;
                }
              }

              if (nextElement.type === 'safety-catch' && nextElement.isLast) {
                // console.log('injecting console before safety catch');
                newConsoleElement.spliceIndex = newConsoleElement.spliceIndex - 1;
              }
            }

            if ((element.type === 'edge' || element.type === 'wall') && newConsoleElement.position) {
              // If the edge is adding a console, then we have to fix it to the left of the basin...
              newConsoleElement.position.x = element.position.x + newConsoleElement.scale.x / 2;
              newConsoleElement.isFixed = true;
              newConsoleElement.isFirst = true;
            }

            if (nextOverhangElement) {
              if ((nextOverhangElement.type === 'edge' || nextOverhangElement.type === 'wall') && nextElement.type !== 'spacer' && newConsoleElement.position) {
                // If the edge is next, then we have to fix console to the right of the basin...
                newConsoleElement.position.x = nextOverhangElement.position.x - newConsoleElement.scale.x / 2;
                newConsoleElement.isFixed = true;
                newConsoleElement.isLast = true;
              }
            } // We're injecting one console at a time to avoid looping problems...


            if (newConsoles.length === 0) {
              newConsoles.push(newConsoleElement);
            }
          }
        }
      }); // We reverse the consoles, and inject them into the elements array... we reverse because we want to avoid affecting index positions when adding the next one

      newConsoles = newConsoles.reverse();
      newConsoles.forEach(function (newConsole, index) {
        elements.splice(newConsole.spliceIndex, 0, newConsole);
      });
      return elements;
    }; // Evenly spacing non-isFixed elements


    this.centerConsoles = function (elements, type) {
      if (type === void 0) {
        type = 'console';
      }

      var inbetweenElements = [];
      var previousWrapperElement = undefined;
      elements.forEach(function (element, index) {
        var isElementsWrapper = // Only trough-trough, or trough-cut-out, or cut-out-cut-out... basically
        element.isAffixableElement && type !== element.type;

        if (isElementsWrapper) {
          // Stretching consoles outwards from the center...
          // After this I could validate the overhangs and see if everything is okay
          // After this validation, stretch consoles inwards to the center... left consoles, then right consoles... buuut, how to do with just 1 console?... maybe a console anchor I guess, which would have negative buffers
          // Validate again
          // Compare validations... if stretching inwards is valid, then accept it
          if (inbetweenElements.length > 0 && typeof previousWrapperElement !== 'undefined') {
            // Now we have the previousWrapperElement, and the current element...
            var inbetweenConsoles = inbetweenElements.filter(function (e) {
              return e.type === 'console';
            }); // We only move consoles
            // Get central console

            var hasCentralConsole = inbetweenConsoles.length % 2 !== 0;

            if (!hasCentralConsole) {
              var consoleCenterAnchor = _this.elementsBuilder.buildConsoleCenterAnchor();

              inbetweenConsoles.splice(Math.round(inbetweenConsoles.length / 2), 0, consoleCenterAnchor);
            } // if (!this.isSimulation) {
            //   console.log('hasCentralConsole', element, hasCentralConsole, JSON.parse(JSON.stringify(inbetweenConsoles)));
            // }


            var halfLength = Math.floor(inbetweenConsoles.length / 2);
            var centralConsole = inbetweenConsoles[halfLength]; // Move central console to center of the 2 elements...

            var centerPosition = previousWrapperElement.outerSides.right + (element.outerSides.left - previousWrapperElement.outerSides.right) / 2;
            centralConsole.position.x = centerPosition;
            centralConsole.isStretched = true; // This is working, without even splicing it in
            // if (!this.isSimulation) {
            //   console.log('centralConsole', JSON.parse(JSON.stringify(centralConsole)), previousWrapperElement.sides.right, element.sides.left);
            // }
            // All elements and positions seems correct so far... first console overhang seems wrong but I think not much to worry about
            // if (betweenConsoles.length > 1) {
            // Stretch outwards... to stretch inwards I literally just have to reverse them

            var leftElements = _this.calc.getElementsBetweenElements([previousWrapperElement].concat(inbetweenConsoles), previousWrapperElement, centralConsole, true);

            _this.stretchOverhangsLeftToRight(leftElements.slice().reverse(), true).reverse();

            var rightElements = _this.calc.getElementsBetweenElements(inbetweenConsoles.concat([element]), centralConsole, element, true);

            _this.stretchOverhangsLeftToRight(rightElements.slice()); // Validate overhangs... 


            var isOverhangsInvalidLeft = !_this.validateOverhangs(leftElements.slice());
            var isOverhangsInvalidRight = !_this.validateOverhangs(rightElements.slice());
            var isOverhangsInvalidBoth = isOverhangsInvalidLeft && isOverhangsInvalidRight; // If 1 side is invalid, but the other side is valid, then we have room to move the consoles around

            if ((isOverhangsInvalidLeft || isOverhangsInvalidRight) && !isOverhangsInvalidBoth) {
              // Which side is invalid, then stretch/limit the overhangs away from that side
              if (isOverhangsInvalidLeft) {
                _this.stretchOverhangsLeftToRight([previousWrapperElement].concat(inbetweenConsoles, [element]));
              } else if (isOverhangsInvalidRight) {
                _this.stretchOverhangsLeftToRight([previousWrapperElement].concat(inbetweenConsoles, [element]).reverse(), true).reverse();
              }
            }
          } // Reset inbetween elements


          inbetweenElements = [];
          previousWrapperElement = element;
        } else if (element.type === type) {
          inbetweenElements = inbetweenElements.concat([element]);
        }
      });
      return elements;
    };

    this.validateOverhangs = function (elements) {
      var isValid = true;
      elements = _this.addOverhangNumbers(elements);
      elements.forEach(function (element, index) {
        if (element.overhangDistance && element.overhangThreshold) {
          if (element.overhangDistance > element.overhangThreshold) {
            isValid = false;
          }
        }
      });
      return isValid; // TODO
    };

    this.stretchOverhangs = function (elements) {
      // if (!this.isSimulation) {
      //   console.log('stretchOverhangs start');
      // }
      var firstAffixableElement = elements.filter(function (e) {
        return e.isAffixableElement;
      })[0];

      var firstElements = _this.calc.getElementsBetweenElements(elements, elements[0], firstAffixableElement, true); // all elements edge to trough, including edge and trough


      _this.stretchOverhangsLeftToRight(firstElements);

      var lastAffixableElement = elements.filter(function (e) {
        return e.isAffixableElement;
      }).reverse()[0];

      var lastElements = _this.calc.getElementsBetweenElements(elements, lastAffixableElement, elements[elements.length - 1], true);

      _this.stretchOverhangsLeftToRight(lastElements.reverse(), true).reverse(); // I'm trying to only apply the stretch overhangs for the first set of elements... however current method is not working for some reason...
      // Is there a way I can do it without splicing... it would mean looping through all elements
      // Thats kind of how I normally do things, but I want to improve the method...
      // Is there a way to only affect a certain set of elements perhaps without using splice...
      // 
      // if (!this.isSimulation) {
      //   console.log('stretchOverhangs end');
      // }


      return elements;
    };

    this.stretchOverhangsLeftToRight = function (elements, isReversed) {
      if (isReversed === void 0) {
        isReversed = false;
      } // if (!this.isSimulation) {
      //   console.log('stretchOverhangsLeftToRight', isReversed);
      // }
      // Would go left to right
      // Tries to move consoles as far to right as possible... idea is to remove the need for spacer/dynamicBuffer and console spacing


      elements = _this.addOverhangNumbers(elements, isReversed); // Prep... need to squash all elements to the left... (or right when reversed is actually most important)
      // const firstOverhangElement = elements.filter(e => e.isOverhangElement || typeof(e.overhangDistance) === 'undefined')[0];
      // const consoles: PlateElement[] = elements.filter(e => e.type === 'console');
      // consoles.forEach((element, index) => {
      //   element.position.x = firstOverhangElement.position.x + (isReversed ? -(element.scale.x + 1) : (element.scale.x + 1));
      // });
      // console.log('firstOverhangElement', firstOverhangElement, consoles);

      elements.forEach(function (element, index) {
        // Why are we only looking at overhangElements not keyElements... a console should be spaced from a console... or a console from an angle-bar...
        if (!element.isOverhangElement || typeof element.overhangDistance === 'undefined' || typeof element.overhangThreshold === 'undefined' || typeof element.nextConsolePosition === 'undefined') {
          return;
        } // const nextElement: PlateElement | undefined = elements[index+1];
        // if (!nextElement) { return; }


        var nextElements = elements.slice(index + 1, elements.length) || [];
        var nextAffixableElement = nextElements.filter(function (e) {
          return e.isAffixableElement;
        })[0];

        var inbetweenElements = _this.calc.getElementsBetweenElements(elements, element, nextAffixableElement);

        if (inbetweenElements.length === 0) {
          return;
        }

        var nextOverhangElement = inbetweenElements.filter(function (e) {
          return e.isOverhangElement;
        })[0];

        var inbetweenCurrentAndOverhangElements = _this.calc.getElementsBetweenElements([element].concat(nextElements), element, nextOverhangElement);

        var inbetweenCurrentAndOverhangElementsWidths = inbetweenCurrentAndOverhangElements.reduce(function (accumulator, el) {
          return accumulator + el.outerWidth;
        }, 0);

        var inbetweenOverhangAndAffixableElements = _this.calc.getElementsBetweenElements([element].concat(nextElements), nextOverhangElement, nextAffixableElement);

        var inbetweenOverhangAndAffixableElementsWidths = inbetweenOverhangAndAffixableElements.reduce(function (accumulator, el) {
          return accumulator + el.outerWidth;
        }, 0);

        if (nextOverhangElement) {
          // element.overhangDistance < element.overhangThreshold // This made it so that it also wasn't limiting the overhangs... maybe the separate function that existed previously is better, I would use it above where I check if overhangs are valid... if not valid then limit overhangs leftToRight
          if (element.overhangDistance !== element.overhangThreshold && (nextOverhangElement.type === 'console' || nextOverhangElement.type === 'consolecenteranchor')) {
            // && !nextOverhangElement.isStretched) { // If I make it check "isStretched" then the centerConsoles is going to break, because on the 2nd loop one of the consoles is stretched... if I want to use this check, I need to make sure to check if console is already stretched and if so then set "isStretched" to true to avoid infinite loop
            if (!isReversed) {
              // if (!this.isSimulation) {
              //   console.log('about this');
              //   console.log(element, nextElements, nextOverhangElement);
              // }
              nextOverhangElement.position.x = element.sides.right + element.nextConsolePosition + nextOverhangElement.scale.x / 2 + nextOverhangElement.buffer.left;
              nextOverhangElement.isStretched = true; // Avoid overlapping next key element... have to include inbetween element widths in the check too

              if (nextAffixableElement) {
                var isOverlappingNextAffixable = nextOverhangElement.outerSides.right > nextAffixableElement.outerSides.left - inbetweenOverhangAndAffixableElementsWidths;

                if (isOverlappingNextAffixable) {
                  nextOverhangElement.position.x = nextAffixableElement.outerSides.left - nextOverhangElement.scale.x / 2 - nextOverhangElement.buffer.right - inbetweenOverhangAndAffixableElementsWidths;
                }

                var isOverlappingCurrentElement = element.type !== 'console' && element.outerSides.right + inbetweenCurrentAndOverhangElementsWidths > nextOverhangElement.outerSides.left;

                if (isOverlappingCurrentElement) {
                  nextOverhangElement.position.x = element.outerSides.right + nextOverhangElement.scale.x / 2 + nextOverhangElement.buffer.left + inbetweenCurrentAndOverhangElementsWidths;
                }
              } // We push all consoles over, and then we adjust to avoid overlap with trough/etc, but it can sometimes cause overlap with console before, so this is fix for that


              var isOverlappingConsole = element.type === 'console' && element.sides.right > nextOverhangElement.sides.left;

              if (isOverlappingConsole) {
                element.position.x = nextOverhangElement.sides.left - element.scale.x / 2;
              }
            } else {
              // Getting confused... because its reversed, we have to do kind of opposite to above... maybe there is another way I can do this but still re-use what is above, like an actual flip of elements or something like that
              nextOverhangElement.position.x = element.sides.left - element.nextConsolePosition - nextOverhangElement.scale.x / 2 - nextOverhangElement.buffer.right;
              nextOverhangElement.isStretched = true; // Avoid overlapping next key element...
              // console.log('nextOverhangElement.outerSides', element, nextOverhangElement, nextAffixableElement, nextOverhangElement.outerSides);

              if (nextAffixableElement) {
                var isOverlappingNextAffixable = nextOverhangElement.outerSides.left < nextAffixableElement.outerSides.right + inbetweenOverhangAndAffixableElementsWidths;

                if (isOverlappingNextAffixable) {
                  nextOverhangElement.position.x = nextAffixableElement.outerSides.right + nextOverhangElement.scale.x / 2 + nextOverhangElement.buffer.left + inbetweenOverhangAndAffixableElementsWidths;
                }

                var isOverlappingCurrentElement = element.type !== 'console' && element.outerSides.left - inbetweenCurrentAndOverhangElementsWidths < nextOverhangElement.outerSides.right;

                if (isOverlappingCurrentElement) {
                  nextOverhangElement.position.x = element.outerSides.left - nextOverhangElement.scale.x / 2 - nextOverhangElement.buffer.right - inbetweenCurrentAndOverhangElementsWidths;
                }
              } // We push all consoles over, and then we adjust to avoid overlap with trough/etc, but it can sometimes cause overlap with console before, so this is fix for that


              var isOverlappingConsole = element.type === 'console' && element.sides.left < nextOverhangElement.sides.right;

              if (isOverlappingConsole) {
                element.position.x = nextOverhangElement.sides.right + element.scale.x / 2;
              }
            }
          }
        }
      });
      return elements;
    };

    this.shiftOverlappingElements = function (elements) {
      elements.forEach(function (element, index) {
        // const element: PlateElement = elements[index];
        // const prevElement: PlateElement | undefined = elements[index - 1];
        var nextElement = elements[index + 1];

        if (!nextElement) {
          return;
        }

        var elementRight = element.outerSides.right;
        var nextElementLeft = nextElement.sides.left; // We are shifting even if there is a negative buffer, so, have to avoid doing this by including the next element buffer

        if (elementRight > nextElementLeft) {
          nextElement.position.x = elementRight + nextElement.buffer.left;
          nextElement.isFixed = true; // Have to make sure I fix the element after shifting it, so that other consoles can be centered from this shifted element
        }
      });
      return elements;
    };

    this.hideElementsByType = function (elements, type) {
      elements.forEach(function (element, index) {
        if (element.type === type) {
          element.hidden = true;
        }
      });
      return elements;
    };

    this.makeInnerElementsRelative = function (elements) {
      var parentElements = elements.filter(function (e) {
        return e.elements && e.elements.length > 0;
      });
      parentElements.forEach(function (element, index) {
        for (var _i = 0, _a = element.elements; _i < _a.length; _i++) {
          var innerElement = _a[_i];
          innerElement.position.x = innerElement.position.x + element.position.x;
          innerElement.position.y = innerElement.position.y + element.position.y;
          innerElement.position.z = innerElement.position.z + element.position.z; // Just in case the child element has more children elements...

          if (innerElement.elements) {
            _this.makeInnerElementsRelative(innerElement.elements);
          }
        }
      });
      return elements;
    };

    this.makeAngleBarsFlush = function (elements) {
      var angleBars = elements.filter(function (e) {
        return e.type === 'angle-bar';
      });
      angleBars.forEach(function (angleBar, index) {
        if (angleBar.isFirst) {
          angleBar.position.x = angleBar.position.x - angleBar.scale.x / 2;
        }

        if (angleBar.isLast) {
          angleBar.position.x = angleBar.position.x + angleBar.scale.x / 2;
        }
      });
      return elements;
    };

    this.getElementWithTroughIndex = function (elements, type, troughIndex) {
      var foundElement;
      elements.forEach(function (element, index) {
        if (element.type === type && element.troughIndex === troughIndex) {
          foundElement = element;
        }
      });
      return foundElement;
    };

    this.conf = conf;
    this.trough = trough;
    this.elementsBuilder = new plate_elements_builder_1.PlateElementsBuilder(this.conf);
    this.calc = new plate_builder_calc_1.PlateCalc(this);
    this.components = this.populate(); // platebuilder is always part of conf
    // and then platebuilder is being passed conf as a property? weird...
    // but platebuilder needs to be able to query the conf functions... so how to improve that?
  }

  return PlateBuilder;
}();

exports.PlateBuilder = PlateBuilder;
exports.default = PlateBuilder;